<template>
  <v-form ref="form">
    <div class="d-flex flex-row align-items-center">
      <div class="col-lg-3">
        <div class="image-preview" v-if="logoPreviewData.length > 0">
            <img style="width: 100%;height: auto;border-radius:5%;" class="preview" :src="logoPreviewData">
        </div>
        <div class="image-preview" v-else>
            <img style="width: 100%;height: auto;border-radius:5%;" class="logo" :src="getPartnerLogo">
        </div>
        <div class="file-upload-form text-center">
            <input id="logo" name="logo" hidden type="file" @change="previewImage" accept="image/*">
        </div>
       
      </div>
      <div class="col-lg-9">
        <!-- Nom -->
        <v-text-field
          v-model="partner.name"
          :rules="nameErrors"
          :counter="255"
          label="Nom du partnenaire *"
          required
        ></v-text-field>

        <!-- URL -->
        <v-text-field
          v-model="partner.url"
          :rules="urlErrors"
          :counter="1000"
          label="URL"
          required
        ></v-text-field>
        
        <!-- LOGO -->
        <v-btn class="float-left mt-5" color="primary" @click="inputLogoClick">
          Modifier le logo
        </v-btn>
      </div>
    </div>
    <v-btn class="float-right mt-5" color="primary" @click="submit">
      Valider
    </v-btn>
  </v-form>
</template>
<script>
import { getPartnerLogoUrl } from '@/core/utils/partner';
import { mapGetters } from "vuex";
export default {
  name: "formClient",
  data() {
    return {
      logoPreviewData: "",
      valid: false,
      nameErrors: [
        (v) => !!v || "Le nom du partenaire est obligatoire.",
        (v) => v.length >= 2 || "Le nom doit être supérieur à 2 caractères",
        (v) => v.length <= 255 || "Le nom doit être inférieur à 255 caractères",
      ],
      urlErrors: [
        (v) => !!v || "L'url du partenaire est obligatoire.",
        (v) =>
          v.length <= 1000 || "L'url doit être inférieur à 1000 caractères",
      ],
    };
  },
  model: {
    prop: "partner",
    event: "input",
  },
  props: {
    partner: Object,
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    getPartnerLogo: function() {
      return getPartnerLogoUrl(this.partner, process.env.BASE_URL + this.layoutConfig("self.nologo"));
    },
  },
  methods: {
    inputLogoClick(){
      var input = document.getElementById('logo');
      input.click();
    },
    previewImage(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            this.partner.newLogo = input.files[0];
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.logoPreviewData" refers to the logoPreviewData of Vue component
                // Read image as base64 and set to logoPreviewData
                this.logoPreviewData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    submit(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.$emit("submit");
      }
    },
  },
  mounted() {

  },
};
</script>
